import Vue from "vue";

import NewsletterSubscribe from "@Scripts/Components/NewsletterSubscribe/NewsletterSubscribe.vue";
import NewsletterUnsubscribe from "@Scripts/Components/NewsletterUnsubscribe/NewsletterUnsubscribe.vue";
import HeaderSearchBox from "@Scripts/Components/Search/HeaderSearchBox.vue";
import PageSearchBox from "@Scripts/Components/Search/PageSearchBox.vue";
import VisualSearchBox from "@Scripts/Components/Search/VisualSearchBox.vue";
import BookingSearch from "@Scripts/Components/BookingSearch/BookingSearch.vue";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("app-newsletter-subscribe", NewsletterSubscribe);
        Vue.component("app-newsletter-unsubscribe", NewsletterUnsubscribe);
        Vue.component("app-header-search-box", HeaderSearchBox);
        Vue.component("app-page-search-box", PageSearchBox);
        Vue.component("app-visual-search-box", VisualSearchBox);
        Vue.component("app-booking-search", BookingSearch);
    }
}